<div class="flex flex-col gap-6">
  <!-- Bank Details -->
  <div class="w-full flex flex-col bg-white rounded-xl pb-6">
    <div
      class="flex w-full justify-between rounded-t-xl py-4 pr-4 border-transparent border-[2px] border-b-gray-300"
    >
      <div class="flex gap-4">
        <div class="h-10 w-1 bg-primary"></div>
        <span>Bank Details</span>
      </div>
      <div
        (click)="bankName = !bankName"
        class="p-1 rounded-full h-6 w-6 bg-gray-300"
      >
        <img src="../../../assets/image/Arrows.svg" />
      </div>
    </div>
    <div *ngIf="bankName" class="w-full">
      <form
        [formGroup]="customerBankDetailsForm"
        class="w-full grid md:grid-cols-2 grid-col-1 gap-4 p-5"
      >
        <div class="flex flex-col gap-2 w-full">
          <span class="text-sm">Bank Name *</span>

          <!-- <input
            formControlName="bankName"
            name="bankName"
            class="w-full border p-2 rounded-md outline-none"
            placeholder="Enter your Bank Name"
          /> -->
          <input *ngIf="(singleRole == 'merchant' || singleRole == 'reseller' ) && loginRole=='admin'" [readonly]="(singleRole == 'merchant' || singleRole == 'reseller' ) && loginRole=='admin'"
          formControlName="bankName"
          name="bankName"
          class="w-full border p-2 rounded-md outline-none"
         
        />
          <select *ngIf="!((singleRole == 'merchant' || singleRole == 'reseller' ) && loginRole=='admin')"
            formControlName="bankName" 
            name="bankName" 
            class="w-full border p-2 rounded-md outline-none"
          >
            <option value="" disabled >--Select Bank--</option>
            <option>State Bank of India (SBI)</option>

            <option value="HDFC Bank">HDFC Bank</option>
            <option value="ICICI Bank">ICICI Bank</option>
            <option>Punjab National Bank (PNB)</option>
            <option>Axis Bank</option>
            <option>Bank of Baroda (BOB)</option>
            <option value="Canara Bank">Canara Bank</option>
            <option>Union Bank of India</option>
            <option>Bank of India (Bol)</option>
            <option>IDBI Bank</option>
            <option>Indian Bank</option>
            <option>Central Bank of India</option>
            <option>Kotak Mahindra Bank</option>
            <option>Yes Bank</option>
            <option>IndusInd Bank</option>
            <option>Federal Bank</option>
            <option>Punjab & Sind Bank</option>
            <option>Indian Overseas Bank (IOB)</option>
            <option>RBL Bank</option>
            <option>South Indian Bank</option>
          </select>
          <div
            *ngIf="
              customerBankDetailsForm.controls['bankName'].touched &&
              !customerBankDetailsForm.controls['bankName'].valid
            "
            class="text-red-500"
          >
            Bank Name Required
          </div>
        </div>
        <div class="flex flex-col gap-2 w-full">
          <span class="text-sm">IFSC Code *</span>

          <input [readonly]="(singleRole == 'merchant' || singleRole == 'reseller' ) && loginRole=='admin'"
            formControlName="ifscCode"
            name="ifscCode"
            class="w-full border p-2 rounded-md outline-none"
            placeholder="Enter Your IFSC Code"
          />
          <div
            *ngIf="
              customerBankDetailsForm.controls['ifscCode'].touched &&
              !customerBankDetailsForm.controls['ifscCode'].valid
            "
            class="text-red-500"
          >
            IFSC Code Required
          </div>
        </div>
        <div class="flex flex-col gap-2 w-full">
          <span class="text-sm">AC. Holder Name *</span>

          <input [readonly]="(singleRole == 'merchant' || singleRole == 'reseller' ) && loginRole=='admin'"
            formControlName="accountHolderName"
            name="accountHolderName"
            class="w-full border p-2 rounded-md outline-none"
            placeholder="Enter Your AC. Holder Name"
          />
          <div
            *ngIf="
              customerBankDetailsForm.controls['accountHolderName'].touched &&
              !customerBankDetailsForm.controls['accountHolderName'].valid
            "
            class="text-red-500"
          >
            Account Holder Name Required
          </div>
        </div>
        <div class="flex flex-col gap-2 w-full">
          <span class="text-sm">Bank Currency *</span>

          <!-- <input *ngIf="((singleRole == 'merchant' || singleRole == 'reseller' ) && loginRole=='admin')"
          [readOnly]="((singleRole == 'merchant' || singleRole == 'reseller' ) && loginRole=='admin')"
            formControlName="bankCurrency"
            name="bankCurrency"
            class="w-full border p-2 rounded-md outline-none"
            placeholder="Enter your Bank Currency"
          /> -->
          <select  
            class="w-full p-2 outline-none border rounded-md"
            formControlName="bankCurrency"
            name="bankCurrency"
            (change)="onCurrencySelect($event)"
          >
            <option value="" disabled>Select Bank Currency</option>
            <option
              *ngFor="let currency of currencyData"
              [value]="currency?._id"
            >
              {{ currency?.title }}
            </option>
          </select>
          <div
            *ngIf="
              customerBankDetailsForm.controls['bankCurrency'].touched &&
              !customerBankDetailsForm.controls['bankCurrency'].valid
            "
            class="text-red-500"
          >
            Currency Is Required
          </div>
        </div>
        <div class="flex flex-col gap-2 w-full">
          <span class="text-sm">Branch Name *</span>

          <input [readonly]="(singleRole == 'merchant' || singleRole == 'reseller' ) && loginRole=='admin'"
            formControlName="branchName"
            name="branchName"
            class="w-full border p-2 rounded-md outline-none"
            placeholder="Enter Your Branch Name"
          />
          <div
            *ngIf="
              customerBankDetailsForm.controls['branchName'].touched &&
              !customerBankDetailsForm.controls['branchName'].valid
            "
            class="text-red-500"
          >
            Branch Name Is Required
          </div>
        </div>
        <div class="flex flex-col gap-2 w-full">
          <span class="text-sm">PAN Card *</span>

          <input [readonly]="(singleRole == 'merchant' || singleRole == 'reseller' ) && loginRole=='admin'"
            formControlName="bankPancard"
            name="bankPancard"
            class="w-full border p-2 rounded-md outline-none"
            placeholder="Enter Your PAN Number"
          />
          <div
            *ngIf="customerBankDetailsForm.controls['bankPancard'].errors?.['pattern'] ||
          (customerBankDetailsForm.controls['bankPancard'].touched &&
          !customerBankDetailsForm.controls['bankPancard'].valid)"
            class="text-red-500"
          >
            Invalid PAN Number
          </div>
        </div>
        <div class="flex flex-col gap-2 w-full">
          <span class="text-sm">Account No *</span>

          <input [readonly]="(singleRole == 'merchant' || singleRole == 'reseller' ) && loginRole=='admin'"
            formControlName="accountNo"
            name="accountNo"
            class="w-full border p-2 rounded-md outline-none"
            placeholder="Enter Your Account No"
            (keypress)="keyPressNumbers($event)"
          />
          <div
            *ngIf="customerBankDetailsForm.controls['accountNo'].errors?.['pattern'] ||
          (customerBankDetailsForm.controls['accountNo'].touched &&
          !customerBankDetailsForm.controls['accountNo'].valid)"
            class="text-red-500"
          >
            Invalid Account Number
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
